import Vue from 'vue'
import { language } from '../util/language'

import br from './brGroup'
import en from './enGroup'

Vue.i18n?.add('br', br)
Vue.i18n?.add('pt-BR', br)

Vue.i18n?.add('en', en)
Vue.i18n?.add('en-US', en)

Vue.i18n?.add('au', en)
Vue.i18n?.add('en-AU', en)

Vue.i18n?.fallback('en')
Vue.i18n?.set(language())
